import React from 'react'
import Topbar from '../Topbar'
import {Button, ButtonToolbar} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import {filter, find} from 'lodash'

import NewScanModal from './modals/index'
import IconTooltip from '../../components/IconTooltip'
import Question from '../../components/Question'
import {buildAnswerMap} from '../../utils'

import * as question from '../../services/question-service'
import * as collaborators from '../../services/collaborator-service'
import * as location from '../../services/location-service'
import * as unitService from '../../services/organizational-units-service'
import * as scanService from '../../services/scan-service'
import * as answerService from '../../services/answer-service'
import * as consultationService from '../../services/consultation-service'

import {CollaboratorsContext} from '../../context/CollaboratorsContext'
import {EmailContext} from '../../context/EmailContext'

export default class NewScan extends React.Component {
  constructor(props) {
    super(props)

    this.validate = this.validate.bind(this)
    this.checkBoxFormatter = this.checkBoxFormatter.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.updateUsePreviousScan = this.updateUsePreviousScan.bind(this)
    this.startScan = this.startScan.bind(this)
    this.cancelNewScan = this.cancelNewScan.bind(this)

    this.state = {
      units: [],
      locations: [],
      collaborators: [],
      questions: {genericQuestions: []},
      answers: [],
      isIntroQuestions: true
    }
  }

  componentDidMount() {
    location.getLocations().then(locations => this.setState({locations}))
  }

  validate() {
    return filter(this.state.answers, a => a.booleanValue).length !== this.state.questions.genericQuestions.length
  }

  getPreviousScan() {
    scanService
      .getMostRecentCompletedScan(this.state.unit.id)
      .then(previousScan => {
        this.setState({previousScan})
      })
      .catch(() => {
      })
  }

  getInitData() {
    Promise.all([collaborators.getCollaboratorsByUnit(this.state.unit.id), question.getQuestion(1, undefined)]).then(
      ([collaborators, questions]) => {
        collaborators.forEach(col => (col.fullName = col.firstName + ' ' + (col.prefix || '') + ' ' + col.lastName))
        this.setState(
          {
            collaborators,
            questions
          },
          () => this.getPreviousScan()
        )
      }
    )
  }

  getUnitsForLocation() {
    if (this.state.location) {
      unitService.getUnitsByLocation(this.state.location.id)
        .then(units => this.setState({units: units, unit: undefined}))
        .catch(() => this.setState({units: [], unit: undefined}))
    }
  }

  handleLocationChange(e) {
    this.setState({location: e}, () => this.getUnitsForLocation())
  }

  handleUnitChange(e) {
    this.setState({unit: e}, () => this.getInitData())
  }

  updateUsePreviousScan(usePreviousScan) {
    this.setState({usePreviousScan})
  }

  cancelNewScan() {
    this.setState({unit: undefined, location: undefined, units: undefined})
    this.props.history.push(`/newscan`)
  }

  startScan() {
    const {unit, answers, previousScan, usePreviousScan, collaborators} = this.state
    scanService
        .startScan({organizationalUnitId: unit.id, id: usePreviousScan ? previousScan.id : undefined})
        .then((response) => {
          const scanId = response.data.id;
          const promises = [];

          answers.forEach((a) => {
            a.scanId = scanId;
            promises.push(answerService.upsertAnswer(a));
          });

          // Add collaborators to the scan
          collaborators
              .filter((col) => col.selected === true)
              .forEach((c) => {
                promises.push(consultationService.addCollaborator({ scanId, collaboratorId: c.id }));
              });

          const commentsFromStorage = localStorage.getItem("comments");
          if (commentsFromStorage) {
            const commentsArray = JSON.parse(commentsFromStorage);
            commentsArray.forEach((comment) => {
              promises.push(
                  answerService.updateAnswer({
                    scanId: scanId,
                    questionId: comment.questionId,
                    comment: comment.comment,
                  })
              );
            });
          }

          Promise.all(promises).then(() => {
            this.props.history.push(`/scans/${scanId}/next`);
          });
        })
        .catch((error) => {
          console.error("Error starting the scan:", error);
        });
  }

  changeCollaborator(row, id) {
    let collaborators = this.state.collaborators
    const isSelected = !collaborators[id].selected
    collaborators[id].selected = isSelected
    collaborators[id].initiallySelected = isSelected
    this.setState({collaborators: collaborators})
  }

  // Dit is specifiek voor de intro-questions, en werkt alleen voor radio selects.
  handleChange(e, values) {
    const optionId = e.target.value
    let answers = this.state.answers

    for (let i = 0; i < values.length; i++) {
      let booleanValue = values[i] === parseInt(optionId, 10)
      let answer = find(answers, a => a.optionId === values[i])
      if (!answer) {
        answer = {optionId: values[i]}
        answers.push(answer)
      }
      answer.booleanValue = booleanValue
    }
    this.setState({answers})
  }

  headerFormatter(column, colIndex, {sortElement}) {
    return (
      <span className="sortable-inner">
        <span className="text">{column.text}</span>
        {sortElement}
      </span>
    )
  }

  contentFormatter(cell, row) {
    return <span className="text">{cell}</span>
  }

  checkBoxFormatter(cell, row, id) {
    return (
      <div className="row-actions">
        <form>
          <div className="checkbox">
            <label>
              <input type="checkbox" onChange={() => this.changeCollaborator(row, id)}/>
              <span className="text">&nbsp;</span>
            </label>
          </div>
        </form>
      </div>
    )
  }

  render() {
    const {questions, units, locations, location, collaborators, answers, unit} = this.state
    const {genericQuestions} = questions


    const columns = [
      {
        dataField: 'button',
        text: ' ',
        formatter: this.checkBoxFormatter
      },
      {
        dataField: 'fullName',
        text: 'Medewerker',
        sort: true,
        headerFormatter: this.headerFormatter,
        formatter: this.contentFormatter
      },
      {
        dataField: 'email',
        text: 'E-mail',
        sort: true,
        headerFormatter: this.headerFormatter,
        formatter: this.contentFormatter
      }
    ]

    return (
      <div className="content table-page col-2 scans new-scan">
        <div className="content-inner">
          <Topbar
            title="Nieuwe scan"
            select={true}
            locations={locations}
            location={location}
            units={units}
            unit={unit}
            disabled={false}
            unitChange={this.handleUnitChange}
            locationChange={this.handleLocationChange}
          />

          <div className="inner">
            {!unit &&
            <p>Kies eerst de locatie en organisatorische eenheid.<br/>
              Indien de gewenste organisatorische eenheid er nog niet tussen staat, moet u deze eerst aanmaken
              onder &lsquo;Organisaties&rsquo;.</p>
            }

            {unit && (
              <div className="scan-container row">
                <div className="scan-section col">
                  <h2>
                    Vragen vooraf{' '}
                    {genericQuestions[0] && (
                      <IconTooltip id={'vragen_vooraf_kop'} icon="far fa-info-circle"/>
                    )}
                  </h2>

                  {genericQuestions &&
                  genericQuestions.map((question, i) => (
                    <Question
                      key={i}
                      question={question}
                      onChange={this.handleChange}
                      state={answers}
                      answermap={buildAnswerMap(questions, answers)}
                      isIntroQuestions={this.state.isIntroQuestions}
                    />
                  ))}
                </div>

                <div className="scan-section col">
                  <h2>Raadplegen medewerkers{' '}
                    <IconTooltip id={'Raadplegen_medewerkers'} icon="far fa-info-circle"/>
                  </h2>
                  <div className="user-table">
                    {this.state.collaborators && (
                      <BootstrapTable
                        keyField="id"
                        data={collaborators}
                        columns={columns}
                        bordered={false}
                        striped
                        hover
                        condensed
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div id="action-buttons">
            {unit &&
            <ButtonToolbar>

              <CollaboratorsContext.Consumer>
                {context => (<Button bsStyle="primary"
                                     disabled={this.validate()}
                                     className="edit-entry action-btn" onClick={(e) => {
                  window.sessionStorage.setItem('collaborators', JSON.stringify(this.state.collaborators))
                  context.updateCollaborators()
                  if (this.state.previousScan) {
                    this.newScanModal.handleShow()
                  } else {
                    this.startScan()
                  }
                }}>
                  Start scan
                </Button>)}
              </CollaboratorsContext.Consumer>
              <EmailContext.Consumer>
                {ctx => {
                  if (ctx.state.shallActivateEmailButton) {
                    ctx.resetEmailContext()
                  }
                }}
              </EmailContext.Consumer>
              <Button className="view-entry action-btn" onClick={this.cancelNewScan}>Annuleren</Button>
            </ButtonToolbar>
            }
          </div>
        </div>

        <NewScanModal
          previousScan={this.state.previousScan}
          usePreviousScan={this.state.usePreviousScan}
          onChange={this.updateUsePreviousScan}
          startscan={this.startScan}
          ref={ref => (this.newScanModal = ref)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/NewScan/index.js